module.exports = {
    "colNum": 12,
    "sizes": [
        {
            "short": "xxs",
            "name": "small-phone",
            "breakpoint": 480,
            "container": "100%",
            "inCss": false
        },
        {
            "short": "xs",
            "name": "phone",
            "breakpoint": 720,
            "container": "100%",
            "inCss": true
        },
        {
            "short": "sm",
            "name": "tablet",
            "breakpoint": 1024,
            "container": "720px",
            "inCss": true
        },
        {
            "short": "md",
            "name": "desktop",
            "breakpoint": 1400,
            "container": "960px",
            "inCss": true
        },
        {
            "short": "lg",
            "name": "large",
            "breakpoint": false,
            "container": "1250px",
            "inCss": true
        }
    ]
}